// global.js
export default {
    //dev环境
    // base_url: "http://localhost:3000",
    // base_upload_url: "http://localhost/api/file/upload",
    // base_upload_url1: "http://localhost/api/file/newUpload",
    // preview_path_url: "http://localhost/images/",

    //test环境
    // base_url: "http://192.140.175.86/base",
    // base_upload_url: "http://192.140.175.86/base/file/upload",
    // base_upload_url1: "http://192.140.175.86/base/file/newUpload",
    // preview_path_url: "http://192.140.175.86/images/",


    base_url: "https://www.lyer.xyz/api",
    base_upload_url: "https://www.lyer.xyz/api/file/upload",
    base_upload_url1: "https://www.lyer.xyz/api/file/newUpload",
    preview_path_url: "https://www.lyer.xyz/images/",
}
